// src/utils/movingAverage.js

/**
 * Compute a simple N-day moving average over an array of numbers.
 * Returns an array of the same length; first N-1 values are null.
 * @param {number[]} values
 * @param {number} window - default 7
 * @returns {(number|null)[]}
 */
export function sevenDayMovingAverage(values = [], window = 7) {
  return values.map((_, i) => {
    if (i < window - 1) return null;
    const slice = values.slice(i - window + 1, i + 1);
    const avg   = slice.reduce((s, v) => s + v, 0) / window;
    return Math.round(avg * 10) / 10;
  });
}

/**
 * Compute 14-day average weight for adaptive notifications.
 * @param {Array<{weight: number}>} entries - sorted oldest first
 * @returns {number|null}
 */
export function fourteenDayAverage(entries = []) {
  const recent = entries.slice(-14);
  if (recent.length === 0) return null;
  return recent.reduce((s, e) => s + e.weight, 0) / recent.length;
}
